/**
 * 会员管理
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async getFormDetail(keyId) {
		return request(api.comm.ECMEMBER + "/" + keyId, METHOD.GET);
	},
	async getEquipmentList(mbrId) {
		return request(api.equipment.EQUIPMENT + "/" + mbrId, METHOD.GET);
	},
	async saveFormDetail(result) {
		return request(api.comm.ECMEMBER + '/saveEcMember', METHOD.POST, result);
	},
	async getCompanyList() {
		return request(api.comm.ECMEMBERCOMPANY + "/popSelect", METHOD.GET);
	},
	async openMember(result) {
		return request(api.comm.ECMEMBER + "/openMember", METHOD.POST, result);
	},
	async closeMember (result) {
		return request(api.comm.ECMEMBER + "/closeMember", METHOD.POST, result);
	},
    async setPassword(result) {
        return request(api.comm.ECMEMBER + '/updatePassword', METHOD.PUT, result)
    },
    async adminModifyPoint(result) {
        return request(api.comm.POINTLOG + '/adminModifyPoint', METHOD.PUT, result)
    },
	async memberEditLabel(result) {
		return request(api.comm.ECMEMBER + '/updateEcMemberTag', METHOD.POST, result)
	},
	async verifiCompany(creditCode,companyName,operName) {
		return request(api.comm.COMPANY + "verifiCompany?creditCode="+creditCode+"&companyName="+companyName+"&operName="+operName, METHOD.GET)
	},
	async companyAll(parent_id) {
		return request(api.comm.COMPANY + "all?filter.eq.parentId="+parent_id, METHOD.GET)
	},
	async audit(result) {
		return request(api.comm.UPDATEAPPLYSTATUS + '/updateApplyStatus', METHOD.GET, result)
	},
	async accountNumber(result) {
		return request(api.comm.CREATEACCOUNT+'/'+result , METHOD.POST)
	},
	async Authorization(result) {
		return request(api.comm.UPDATEUSERSHOPID, METHOD.GET,result)
	},
	async selection(params) {
        return request(api.client.SELECTION, METHOD.GET, params)
    }
}


export default {dataApi}